
export const printContent = (elementId: string, title: string) => {
    const content = document.getElementById(elementId);
    if (!content) return;
    const printWindow = window.open('', '_blank', 'width=1100,height=800');
    if (printWindow) {
        printWindow.document.write(`
            <html>
                <head>
                    <title>${title}</title>
                    <style>
                        @media print {
                            @page { size: landscape; margin: 10mm; }
                            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        }
                        body { font-family: sans-serif; }
                        table { width: 100%; border-collapse: collapse; font-size: 10px; text-align: center; }
                        th, td { border: 1px solid #000; padding: 2px; }
                        th { background-color: #f3f4f6; }
                        .bg-sunday { background-color: #fee2e2 !important; }
                        .bg-saturday { background-color: #eff6ff !important; }
                    </style>
                </head>
                <body>${content.innerHTML}</body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => { printWindow.print(); }, 500);
    } else {
        alert('ポップアップがブロックされました。');
    }
};
